import { Tag } from '@varo/graphql-schema-types';
import { getTagType } from 'features/rewards/Details/MultiStepIncentiveScreen/multiStepProgress.helper';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Tag as TagComponent } from 'shared/components/vxl/Tag/Tag';

type MultiStepTagProps = Omit<Tag, 'id' | 'color'>;

const MultiStepTag = ({ text, tagColor, icon }: MultiStepTagProps) => {
  return (
    <View style={styles.tagContainer}>
      <TagComponent
        text={text ?? ''}
        type={getTagType(tagColor)}
        iconKey={icon}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  tagContainer: { flex: 1 },
});

export default MultiStepTag;
